var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86747 13.0971V11.0288C3.86747 10.3417 4.40581 9.72548 5.17081 9.72548C5.85789 9.72548 6.47414 10.2638 6.47414 11.0288V13.0192C6.47414 14.4005 5.32664 15.548 3.94539 15.548C2.56414 15.548 1.41664 14.3934 1.41664 13.0192V8.6559C1.33872 4.67507 4.48372 1.45215 8.46456 1.45215C12.4454 1.45215 15.5833 4.67506 15.5833 8.57798V12.9413C15.5833 14.3226 14.4358 15.4701 13.0546 15.4701C11.6733 15.4701 10.5258 14.3226 10.5258 12.9413V10.9509C10.5258 10.2638 11.0641 9.64756 11.8291 9.64756C12.5162 9.64756 13.1325 10.1859 13.1325 10.9509V13.0971",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.cb4c5cc65256039f209bfc0e47039d94.svg";
export { ForwardRef as ReactComponent };